module.exports = __webpack_public_path__ + "img/Katarina_home_11.299c6d6d.jpg";